import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'next-i18next'
import { useContext, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { ForgotPasswordFormSchema } from 'services/validation/auth/forgotPassword'
import { AuthModal } from './AuthModal'
import { TitleText } from './AuthModal.style'
import { AuthModalContext } from './AuthModalContext'
import { ForgotPasswordForm } from './ForgotPasswordForm'
import { ForgotPasswordFormValues } from './ForgotPasswordFormValues'

export const ForgotPasswordModal = () => {
  const {
    modalParams: { email }
  } = useContext(AuthModalContext)

  const { t } = useTranslation('authentication')
  const methods = useForm<ForgotPasswordFormValues>({
    resolver: yupResolver(ForgotPasswordFormSchema()),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  })

  useEffect(() => {
    if (email) {
      methods.setValue('email', email)
    }
  }, [email])

  return (
    <AuthModal modalState="FORGOT_PASSWORD">
      <TitleText>{t('forgotPassword.modalTitle')}</TitleText>

      <FormProvider {...methods}>
        <ForgotPasswordForm />
      </FormProvider>
    </AuthModal>
  )
}
